import { render } from "./Cursorflor.vue?vue&type=template&id=18ff01e2"
import script from "./Cursorflor.vue?vue&type=script&lang=js"
export * from "./Cursorflor.vue?vue&type=script&lang=js"

import "./Cursorflor.vue?vue&type=style&index=0&id=18ff01e2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__